import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';


@Injectable({
  providedIn: 'root'
})
export class TipoClienteService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          tipo_cliente {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_cliente.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerTodosYSinTipoCliente(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          tipo_cliente {
            obtenerTodosYSinTipoCliente {
              respuesta {
                registros {
                  codigo
                  descripcion
                  idcanal
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_cliente.obtenerTodosYSinTipoCliente
        callback({ mensajes, respuesta })
      }
    );
  }

}
